(function() {
  'use strict';
  angular.module('common')
  .directive('dnPhone', ['cursorPosition','phoneServices', function (cursorPosition,phoneServices) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, element, attrs, ngModelController) {
        var prevValue = '';
        ngModelController.$parsers.push(function(val) {
          if (!val) {
            return '';
          }
          var viewValue = '';
          var cursorPos = cursorPosition(element[0]);
          if (!phoneServices.isAllowedSeparator(val.charAt(cursorPos-1),cursorPos-1)) {
            val = val.replace(val.charAt(cursorPos-1),'');
          }
          var isDelete = (prevValue && val && val.length < prevValue.length);
          prevValue = val;
          if (!isDelete) {
            viewValue = phoneServices.getSeperator(0);
            if (cursorPos === 1 && val.charAt(0) !== viewValue.charAt(0)) {
               cursorPos += 1;
            }
            val = phoneServices.getPhoneDigits(val);
            viewValue = phoneServices.formatPhoneNumber(val);
            prevValue = viewValue;
            ngModelController.$setViewValue(viewValue);
            ngModelController.$render();
          }
          var seperators =  phoneServices.getSeperator(cursorPos);
          if (!isDelete && seperators && viewValue.substring(cursorPos,cursorPos+seperators.length) === seperators) {
             cursorPos += seperators.length;
          }
          element[0].setSelectionRange(cursorPos,cursorPos);
          return val;
        });
        ngModelController.$formatters.push(function(val) {
          return val ? phoneServices.formatPhoneNumber(val) : val;
        });
        ngModelController.$validators.phoneNumberFormat = function(val) {
          if (!val) {
            return true;
          }
          return phoneServices.isValidPhoneNumber(val);
        };
      }
    };
  }]).filter('phone', ['phoneServices', function(phoneServices) {
    return function(val) {
      return val ? phoneServices.formatPhoneNumber(phoneServices.getPhoneDigits(val)) : val;
    };
  }]).factory('phoneServices',['$log',function($log) {
    var allButDigits = /\D+/g;
    var seperators = [[0,"(",],[4,")"],[5," "],[9,"-"]];
    var maxLength = 10;
    var isADigit = /\d/;
    function isValidPhoneNumber(val) {
      return val && val.replace(allButDigits,'').length === maxLength;
    }
    function isAllowedSeparator(char, index) {
        return isADigit.test(char) || (_.find(seperators, (s) => {return  s[0]===index && s[1]===char;}));
    }
    function getSeperator(index) {
      var separators ='';
      var nextSeparator = [];
      for (var seperatorNdx = index; nextSeparator; seperatorNdx++) {
        nextSeparator = (_.find(seperators, (s) => { return s[0]===seperatorNdx ? s[1] : '';}));
        if (nextSeparator) {
          separators += nextSeparator[1];
        }
      }
      return separators;
    }
    function getPhoneDigits(val) {
      if (val) {
        val = val.replace(allButDigits,'');
        if (val && val.length > maxLength) {
          val = val.substring(0, maxLength);
        }
      }
      return val;
    }
    function formatPhoneNumber(val) {
      var viewValue = getSeperator(0);
      for (var index =0; (val && index < val.length); index++) {
        viewValue += val.charAt(index);
        viewValue += getSeperator(viewValue.length);
      }
      return viewValue;
    }
    return {
      getSeperator: getSeperator,
      formatPhoneNumber: formatPhoneNumber,
      getPhoneDigits: getPhoneDigits,
      isAllowedSeparator: isAllowedSeparator,
      isValidPhoneNumber: isValidPhoneNumber
    };
  }]);
})();
